/* @flow */

import type DiscoveryFeeds from '@homeaway/graphql-traveler-discovery';
import {reportError} from '@homeaway/react-error-reporter';

export const SEARCH_TERM_CAROUSEL_RESULTS_MIN = 250;

export const logSearchTermCarousel = (
    discoveryXploreFeeds: DiscoveryFeeds,
    resultCount: ?number,
    lbsId: ?string,
    filter: ?(string[])
) => {
    if (
        resultCount &&
        resultCount < SEARCH_TERM_CAROUSEL_RESULTS_MIN &&
        discoveryXploreFeeds &&
        discoveryXploreFeeds.results.length > 0
    ) {
        reportError({
            name: 'search term carousel, results number less 250',
            logData: {
                lbsId,
                resultCount,
                filter,
                carouselId: discoveryXploreFeeds.results[0].id
            }
        });
    } else if (
        resultCount &&
        resultCount >= SEARCH_TERM_CAROUSEL_RESULTS_MIN &&
        discoveryXploreFeeds &&
        discoveryXploreFeeds.results.length === 0
    ) {
        reportError({
            name: 'search term carousel, no child destinations',
            logData: {
                lbsId,
                resultCount,
                filter
            }
        });
    }
};
